// App.js
import { ThemeProvider } from "@mui/material/styles";
import React, { Suspense, useEffect, Fragment } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MomentUtils from "@date-io/moment";
import moment from "moment";
import PageLoading from "./component/PageLoading";
import ButtonCircular from "./component/ButtonCircular";
import { routes } from "./routes";
import { createBrowserHistory } from "history";
import AuthContext from "./context/Auth";
import AuthGuard from "./component/AuthGuard";
// import { createTheme } from "./theme";
import { Toaster } from "react-hot-toast";
import { createCustomTheme } from "./theme/index";
import { jwtDecode } from 'jwt-decode';

const history = createBrowserHistory();

function App() {
  const theme = createCustomTheme();


  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decodedToken.exp < currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };
  // useEffect(() => {
  //   const checkTokenExpiration = () => {
  //     const token = localStorage.getItem('token');
  //     if (token) {
  //       if (isTokenExpired(token)) {
  //         localStorage.removeItem('token');
  //         history.push('/');
  //       }
  //     } else {
  //       history.push('/');
  //     }
  //   };
  //   checkTokenExpiration();
  //   // Set an interval to check token expiration every 5 second (5000 ms)
  //   const intervalId = setInterval(checkTokenExpiration, 10000);
  //   // Clean up the interval when the component unmounts
  //   return () => clearInterval(intervalId);
  // }, [history]);


  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        history.push('/');
      }
    } else {
      history.push('/');
    }
  }, [history.location.pathname]);


  // this is also worfing fine
  // const JWT = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NmNmZmQ5OTY2Yzk2ZGVkNjc5YjExZWYiLCJlbWFpbCI6Im11a2VzaEBhZHMyNDczNjUuY29tIiwiaWF0IjoxNzI2Mjk3NDM2LCJleHAiOjE3MjYzODM4MzZ9.HIxsZcD4L67FWNf3cn2BkRfHCv_jJNul32G9F4j1uU8";
  // const jwtPayload = JSON.parse(window.atob(JWT.split('.')[1]))
  // const isExpired = Date.now() >= jwtPayload.exp * 1000;
  // console.log("isExpired", isExpired)
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AuthContext history={history}>
            <Router history={history}>
              <Suspense fallback={<PageLoading />}>
                <Switch>
                  {routes.map((route, i) => {
                    const Component = route.component;
                    const Guard = route.guard ? AuthGuard : Fragment;
                    const Layout = route.layout || Fragment;
                    return (
                      <Route
                        exact={route.exact}
                        key={i}
                        path={route.path}
                        render={(props) => (
                          <Guard>
                            <Layout>
                              {route.routes ? (
                                <RenderRoutes data={route.routes} history={history} />
                              ) : (
                                <Component {...props} history={history} />
                              )}
                            </Layout>
                          </Guard>
                        )}
                      />
                    );
                  })}
                </Switch>
              </Suspense>
            </Router>
            <Toaster
              position="top-center"
              autoClose={5000}
              toastOptions={{
                style: {
                  fontFamily: 'Roboto, sans-serif',
                }
              }}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </AuthContext>
        </LocalizationProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;

function RenderRoutes({ data, history }) {
  return (
    <Suspense fallback={<PageLoading />}>
      <Switch>
        {data.map((route, i) => {
          const Component = route.component;
          const Guard = route.guard ? AuthGuard : Fragment;
          const Layout = route.layout || Fragment;
          return (
            <Route
              exact={route.exact}
              key={i}
              path={route.path}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      <RenderRoutes data={route.routes} history={history} />
                    ) : (
                      <Component {...props} history={history} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
}
